import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import { Avatar } from '@material-ui/core';
import MyAvatarImage from './MyAvatarImage';
import MyAvatarName from './MyAvatarName';

const defaultAvatarSize = 40;

const MyAvatar = (props) => {
  const {
    src,
    alt,
    name,
    size,
    className,
    backgroundColor,
    'data-testid': dataTestId,
  } = props;
  const theme = useTheme();
  const style = {
    height: size,
    width: size,
    fontSize: size === defaultAvatarSize ? undefined : theme.typography.pxToRem(size * 0.75),
    backgroundColor,
  };

  if (src) {
    return (
      <MyAvatarImage
        style={style}
        className={className}
        src={src}
        alt={alt}
        data-testid={dataTestId}
      />
    );
  }

  if (name) {
    // eslint-disable-next-line no-unused-vars
    const { backgroundColor: bgColor, ...style2 } = style;
    return (
      <MyAvatarName
        style={style2}
        className={className}
        name={name}
        backgroundColor={backgroundColor}
        data-testid={dataTestId}
      />
    );
  }

  return (
    <Avatar
      style={style}
    />
  );
};

MyAvatar.propTypes = {
  alt: PropTypes.string,
  name: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.number,
  backgroundColor: PropTypes.string,

  'data-testid': PropTypes.string,
};

MyAvatar.defaultProps = {
  alt: undefined,
  name: undefined,
  src: undefined,
  size: defaultAvatarSize,
  backgroundColor: undefined,

  'data-testid': undefined,
};

export default MyAvatar;
